import type { KeycloakServerConfig } from 'keycloak-js';

const isAbsoluteUrl = (value: string): boolean => /^https?:\/\//i.test(value);

export const resolveAuthUrl = (value: string): string => {
  if (isAbsoluteUrl(value)) {
    return value;
  }

  if (typeof window === 'undefined') {
    const appUrl = typeof process !== 'undefined' && process.env?.['APP_URL'];
    if (appUrl) {
      const path = value.startsWith('/') ? value : `/${value}`;
      return `${appUrl}${path}`;
    }

    return value;
  }

  if (!window.location?.origin) {
    return value;
  }

  const path = value.startsWith('/') ? value : `/${value}`;
  return `${window.location.origin}${path}`;
};

export const parseKeycloakAuthority = (
  authority: string,
  clientId: string,
): KeycloakServerConfig => {
  const normalizedAuthority = authority.replace(/\/$/, '');
  const match = normalizedAuthority.match(
    /^(https?:\/\/.+?)\/realms\/([^/]+)$/i,
  );

  if (!match) {
    throw new Error(`Unsupported Keycloak authority format: ${authority}`);
  }

  return {
    url: match[1],
    realm: match[2],
    clientId,
  };
};

export const buildSilentCheckSsoRedirectUri = (): string | undefined => {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return undefined;
  }

  return `${window.location.origin}/silent-check-sso.html`;
};
